export default "__VITE_ASSET__ioBgEGxmrHVb8zfNN24kzQ__"